"use strict";

exports.__esModule = true;
exports.createSystemConfig = createSystemConfig;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function createSystemConfig(config) {
  var defaultScale = config.defaultScale,
      properties = config.properties,
      property = config.property,
      scale = config.scale,
      _config$transform = config.transform,
      transform = _config$transform === void 0 ? _lodash["default"] : _config$transform;
  var styleProperty = properties != null ? properties : property ? [property] : [];

  var systemConfig = function systemConfig(value, scale, props) {
    var result = {};
    var parsedValue = transform(scale, value, value, props);
    if (parsedValue === null) return;
    styleProperty.forEach(function (prop) {
      if (prop) {
        result[prop] = parsedValue;
      }
    });
    return result;
  };

  systemConfig.defaultScale = defaultScale;
  systemConfig.properties = properties;
  systemConfig.property = property;
  systemConfig.scale = scale;
  systemConfig.transform = transform.name !== 'get' ? transform : undefined;
  return systemConfig;
}